var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCl100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.49967H12.35C12 1.53301 11.0833 0.833008 10 0.833008C8.91667 0.833008 8 1.53301 7.65 2.49967H2.5V17.4997H17.5V2.49967ZM10 2.49967C10.4583 2.49967 10.8333 2.87467 10.8333 3.33301C10.8333 3.79134 10.4583 4.16634 10 4.16634C9.54167 4.16634 9.16667 3.79134 9.16667 3.33301C9.16667 2.87467 9.54167 2.49967 10 2.49967ZM8.33333 14.1663L5 10.833L6.175 9.65801L8.33333 11.808L13.825 6.31634L15 7.49967L8.33333 14.1663Z",
    fill: "#017a4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl100);
export default __webpack_public_path__ + "static/media/cl100.dd0e46d404cca0c46f8805fc71aa32b7.svg";
export { ForwardRef as ReactComponent };